const AbstractResourcesView = require("common/AbstractResourcesView");
const Utils = require("common/Utils");

/**
 * Display a list of Dynamic Apps
 *
 * @constructor
 * @extends {AbstractResourcesView}
 * @param launcher {function} - callback
 */
function DynAppsListView(launcher) {
    AbstractResourcesView.call(this, launcher);

    const contentClass = "dynapps";
    this.getContent().attr("data-nav-icon-class", contentClass);

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "DynAppsList";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getWeight = function() {
        return 25;
    };

    const super_headerConf = this.getHeaderConfiguration;

    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        return $.extend(super_headerConf(), {
            title : $.t("common::resources.filter.dynapps"),
            i18n : "common::resources.filter.dynapps",
            contentClass : contentClass
        });
    };
}

Utils.inherits(DynAppsListView, AbstractResourcesView);

module.exports = DynAppsListView;